import en from "./en.json";
import de from "./de.json";
import es from "./es.json";
import fr from "./fr.json";
import he from "./he.json";
import hev from "./hev.json";
import hi from "./hi.json";
import id from "./id.json";
import it from "./it.json";
import ja from "./ja.json";
import pl from "./pl.json";
import pt from "./pt.json";
import ru from "./ru.json";
import sv from "./sv.json";
import th from "./th.json";


const translations = {
  en,
  de,
  es,
  fr,
  he,
  hev,
  hi,
  id,
  it,
  ja,
  pl,
  pt,
  ru,
  sv,
  th,
};

export const gameLanguages = {
  en,
  de,
  es,
  it,
  pl,
  ru,
}

export default translations;
